export default class Controller {
    get COMMONS (){
        return [
            'Header',
            'Footer',
            'MobileMenu',
            'DesktopMenu',
            'CustomModal',
            'LanguageDropdown',
            'DateInputs',
            'CartTogglers',
            'CartCounters',
            'CartPurchaseCta',
            'ListingScroller',
        ];
    }
    get COMPONENTS_LIST(){
        return [
            'CartComponent',
            'PageFilters',
            'CartContentSection',
            'CardCourse',
            'FormOrderCreator',
            'AreaColorComponent',
        ];
    }
    constructor() {
        this.initCommonComponents();
        this.initFromListComponents();
    }

    initFromListComponents(){
        this.COMPONENTS_LIST.forEach( component =>{
            this.instanceComponent(component);
        })
    }

  initCommonComponents() {
        this.COMMONS.forEach(comp =>{
            this.importComponents(comp).then(({default:common})=> new common());
        });

        // naba square components
        this.importComponents(`NabaSquare`).then(({ default: squareClass }) => {
          const squaresList = document.querySelectorAll(".nabasquare");
          for (let squareElement of squaresList) {
            let squareInstance = new squareClass(squareElement);
          }
        });
    }


    instanceComponent(ComponentName){
        let selector = `[data-component="${ComponentName}"]`;
        if(document.querySelector(selector)){
            let componentElements = document.querySelectorAll(selector);
            componentElements.forEach( element =>{
                this.importComponents(ComponentName)
                .then(({ default:ComponentName })=>{
                    new ComponentName(element);
                })
            })
        }
    }


  /* --------------------------------------------------------------------- */
  /* this method import a module and returns the import promise            */
  /* with this method we centralize the dynamic import                     */
  /* --------------------------------------------------------------------- */
  async importComponents(componentName) {
    return await import(/* webpackChunkName:`component-[request]` *//* webpackMode: "lazy" */`../components/${componentName}`);
  }
}
